'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var reactIntl = require('react-intl');
var List = _interopDefault(require('@material-ui/core/List'));
var ListItem = _interopDefault(require('@material-ui/core/ListItem'));
var CircularProgress = _interopDefault(require('@material-ui/core/CircularProgress'));
var ListItemText = _interopDefault(require('@material-ui/core/ListItemText'));
var SelectConversationListElement = require('../SelectConversationListElement/SelectConversationListElement.js');

var pageSize = 40;
var SelectConversationList = function (props) {
    var getMore = props.getMore, onDelete = props.onDelete, onMarkRead = props.onMarkRead, onSelect = props.onSelect;
    var fm = reactIntl.useIntl().formatMessage;
    var fmPrefix = 'componentLib.conversationList.selectConversation';
    var _a = React.useState([]), conversations = _a[0], setConversations = _a[1]; // reshape this after we know the shape of the resposne.
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var _c = React.useState(true), hasMore = _c[0], setHasMore = _c[1];
    var _d = React.useState(0), page = _d[0], setPage = _d[1];
    var _e = React.useState(true), initialLoad = _e[0], setInitialLoad = _e[1];
    var _f = React.useState(false), error = _f[0], setError = _f[1];
    var _g = React.useState(0), selectedIndex = _g[0], setSelectedIndex = _g[1];
    var onSelectCallback = React.useCallback(onSelect, []);
    var chooseSelected = React.useCallback(function (conversation, i) {
        setSelectedIndex(i);
        onSelectCallback(conversation, i);
    }, [onSelectCallback]);
    var conversationList = React.useRef(null);
    var listener = function (event) {
        var target = event.target;
        if (loading || !hasMore || !target) {
            return;
        }
        if (target.scrollHeight - window.innerHeight < target.scrollTop + 100) {
            setLoading(true);
            getMore(page + 1).then(function (result) {
                setConversations(tslib.__spreadArrays(conversations, result));
                setPage(page + 1);
                if (result.length < pageSize) {
                    setHasMore(false);
                }
                setLoading(false);
                setError(false);
            });
        }
    };
    React.useEffect(function () {
        var current = conversationList === null || conversationList === void 0 ? void 0 : conversationList.current;
        if (current) {
            current.addEventListener('scroll', listener);
        }
        return function () {
            if (current) {
                current.removeEventListener('scroll', listener);
            }
        };
    });
    var doConversationStuff = React.useCallback(function () { return tslib.__awaiter(void 0, void 0, void 0, function () {
        var result, _a;
        return tslib.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getMore(page + 1)];
                case 2:
                    result = _b.sent();
                    setConversations(tslib.__spreadArrays(conversations, result));
                    if (result.length > 0 && initialLoad) {
                        chooseSelected(result[0], 0);
                    }
                    setPage(page + 1);
                    setInitialLoad(false);
                    if (result.length < pageSize) {
                        setHasMore(false);
                    }
                    setLoading(false);
                    setError(false);
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    setError(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [chooseSelected, conversations, getMore, initialLoad, page]);
    React.useEffect(function () {
        if (initialLoad) {
            doConversationStuff();
        }
    }, [initialLoad, doConversationStuff]);
    if (error) {
        return (React__default.createElement(List, { ref: conversationList, id: 'conversation_select_scroll' },
            React__default.createElement(ListItem, null,
                React__default.createElement(ListItemText, { primary: fm({ id: fmPrefix + ".primaryError" }), secondary: fm({ id: fmPrefix + ".secondaryError" }) }))));
    }
    if (conversations.length === 0) {
        return (React__default.createElement(List, { ref: conversationList, id: 'conversation_select_scroll' },
            React__default.createElement(ListItem, null,
                React__default.createElement(ListItemText, { primary: fm({ id: fmPrefix + ".noConversationsPrimary" }), secondary: fm({ id: fmPrefix + ".noConversationsSecondary" }) }))));
    }
    return (React__default.createElement(List, { ref: conversationList, id: 'conversation_select_scroll', style: { maxHeight: window.innerHeight, overflowY: 'scroll' } },
        conversations.map(function (conversation, i) {
            var deleteConversation = function () {
                onDelete(conversation.id);
            };
            var markRead = function () {
                onMarkRead(conversation.read, conversation.id);
            };
            var handleSelect = function () {
                chooseSelected(conversation, i);
            };
            return (React__default.createElement(SelectConversationListElement, { key: conversation.messages[0].text + conversation.contact.name, selected: selectedIndex === i, read: conversation.read, onClickDelete: deleteConversation, onClickRead: markRead, name: conversation.contact.name, latestMessageText: conversation.messages[0].text, latestMessageTime: conversation.messages[0].sentAt, onClickSelect: handleSelect }));
        }),
        hasMore && (React__default.createElement(ListItem, null,
            React__default.createElement(ListItemText, { primary: fm({ id: fmPrefix + ".loading" }), secondary: React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(CircularProgress, null)) })))));
};

module.exports = SelectConversationList;
